import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useModal } from '@gumtree/shell/src/use-modal';
import { LoginModalType } from '@gumtree/shell/src/reducers/common/login-modal';
import { trackGA4PreNav } from '@gumtree/shared/src/util/ga4-shared';

import { VipState } from '../../reducers';
import { SellerBuyBlockContainer, BuyButtonContainer, StyledButton } from './index.style';
import RenderPriceBlock from './render-price-block';

export const BuyButton = ({ isStickyHeader }: { isStickyHeader?: boolean }) => {
    const { id, isCurrentUserSeller, userData } = useSelector(
        ({ adDetails: { id, isCurrentUserSeller }, userData }: VipState) => ({
            id,
            isCurrentUserSeller,
            userData,
        }),
        shallowEqual
    );
    const { openDialog } = useModal();

    const userLoggedIn = !!userData && userData.userLoggedIn;

    const handleClick = (e) => {
        if (!userLoggedIn) {
            openDialog(e, LoginModalType.DELIVERY, true);
            return;
        }

        trackGA4PreNav<GA4.ClickBuyNowButtonEvent>({
            event: 'click_button_buy_now',
            advertId: String(id),
        });

        window.location.href = `/create-order?advertId=${id}`;
    };

    return (
        <StyledButton
            display="primary"
            label="Buy now"
            disabled={Boolean(isCurrentUserSeller)}
            isStickyHeader={isStickyHeader}
            onClick={handleClick}
        />
    );
};

const SellerBuyBlock: React.FC<Props> = ({ isMobileCardsLayout, setIsBuyerProtectionOpen }) => {
    const { price, deliveryFromPrice, buyerProtectionPrice, l2CategoryId } = useSelector(
        ({
            adDetails: { price, deliveryFromPrice, buyerProtectionPrice, l2CategoryId },
        }: VipState) => ({
            price,
            deliveryFromPrice,
            buyerProtectionPrice,
            l2CategoryId,
        }),
        shallowEqual
    );

    return (
        <SellerBuyBlockContainer isMobileCardsLayout={isMobileCardsLayout}>
            <RenderPriceBlock
                price={price}
                deliveryFromPrice={deliveryFromPrice}
                buyerProtectionPrice={buyerProtectionPrice}
                l2CategoryId={l2CategoryId}
                setIsBuyerProtectionOpen={setIsBuyerProtectionOpen}
            />
            <BuyButtonContainer>
                <BuyButton />
            </BuyButtonContainer>
        </SellerBuyBlockContainer>
    );
};

interface Props {
    isMobileCardsLayout: boolean;
    setIsBuyerProtectionOpen?: (isOpen: boolean) => void;
}

export default SellerBuyBlock;
